<template>
  <v-app-bar clipped-left dense app extended>
    <!--scroll-off-screen-->

    <Breadcrumbs />

    <v-spacer></v-spacer>

    <QuickSearch @select="onSelect" @all-contacts="runSearchAll()" @simple-search="runSimpleSearch($event)" :placeholder="$t('HEADER_QUICKSEARCH_LABEL')" :receives_newsletters="false"/>

    <v-btn @click="newContact" icon data-qa="new-contact">
      <v-icon>mdi-account-plus</v-icon>
    </v-btn>

    <v-menu bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          text
        >
          <span v-if="user.fullname" data-qa="fullName">{{ user.fullname }}</span>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, i) in menuUser"
          :key="i"
          @click="item.onclick()"
          :data-qa="item['data-qa']"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>




    <!-- Temporary disable FLAG drop-down -->
    <!--===- ->
    <v-menu bottom left disabled>
      <v-btn
        slot="activator"
        icon
      >
        <flag :iso="currentFlag" :squared="false" />
      </v-btn>
      <v-list>
        <v-list-item
          v-for="lang in langs"
          :key="lang.locale"
          @click="changeLocale(lang)"
        >
          <v-list-item-content>
            <v-list-item-title><flag :iso="getFlag(lang.locale_lang)" :squared="false" :title="lang.name" /></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <!- -===-->


    <v-progress-circular style="width: 175px;" v-if="isBusy" indeterminate></v-progress-circular>
    <img
      v-else
      src="../assets/logo.png"
      height="44"
      style="width: 175px;"
      :title="`(c) dimedis GmbH, Köln ${appVersion}`"
    />

    <!--MENU - Begin-->
    <v-menu bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          text
        >
        <v-icon>menu</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, i) in menuItems"
          :key="i"
          @click="item.onclick()"
          :data-qa="item['data-qa']"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- MENU - End -->

    <template v-slot:extension>
      <v-toolbar ref="refToolbar" flat dense v-show="false">
        <!-- <v-btn
          v-for="button in toolbar"
          :key="button.id"
          :flat="button.flat"
          :disabled="button.disabled"
          :color="button.color"
          @click="button.callback()"
        >
          <v-icon v-if="button.icon">{{ button.icon }}</v-icon>
          {{ button.label }}
        </v-btn> -->
      </v-toolbar>
      <!-- <v-progress-linear :indeterminate="true" class="ma-0">Progress?</v-progress-linear> -->
    </template>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '../store';

import Breadcrumbs from './Breadcrumbs'
import QuickSearch from './QuickSearch'

export default {
  name: 'Toolbar',
  components: {
    Breadcrumbs,
    QuickSearch,
  },
  props: ['refToolbar'],
  data () {
    return {
      // items: [
      //   { title: 'Home', onclick: this.goHome },
      //   { title: 'Settings', onclick: this.goSettings },
      //   { title: 'Quit session', onclick: this.logout},
      // ],
      // languages: [
      //   { flag: 'de', locale: 'de_DE', title: 'Deutsch' },
      //   { flag: 'us', locale: 'en_US', title: 'English' },
      //   { flag: 'bg', locale: 'bg_BG', title: 'Български' },
      //   { flag: 'ru', locale: 'ru_RU', title: 'Русский' },
      // ],
      langMap: [
        { locale_lang: 'de', flag: 'de' },
        { locale_lang: 'en', flag: 'us' },
        { locale_lang: 'bg', flag: 'bg' },
        { locale_lang: 'ru', flag: 'ru' },
        { locale_lang: 'fr', flag: 'fr' },
        { locale_lang: 'sv', flag: 'se' },
      ],
    }
  },
  computed: {
    ...mapGetters(['user', 'isBusy', 'languages', 'toolbar']),
    menuUser() {
      return [
        // { title: this.$t('TOOLBAR_MENU_SETTINGS'), onclick: this.goSettings, 'data-qa': 'settings' },
        { title: this.$t('TOOLBAR_MENU_QUIT_SESSION'), onclick: this.logout, 'data-qa': 'quit-session' },
      ]
    },
    menuItems() {
      return [
        // { titlall-contactse: this.$t('TOOLBAR_MENU_HOME'), onclick: this.goHome, 'data-qa': 'home' },
        { title: this.$t('TOOLBAR_MENU_MAILINGS'), onclick: this.goMailings, 'data-qa': 'mailings' },
        { title: this.$t('TOOLBAR_MENU_DASHBOARD'), onclick: this.goDashboard, 'data-qa': 'dashboard' },
      ]
    },
    langs() {
      return this.languages.filter(a => Object.keys(this.$i18n.messages).includes(a.locale))
    },
    currentFlag() {
      const lang = this.languages.find(a => a.locale === this.$i18n.locale)
      return lang ? this.getFlag(lang.locale_lang) : ''
    },
    appVersion() { 
        return store.getters.appVersion;
    },
  },
  mounted() {
    this.$emit('refToolbar', this.$refs.refToolbar)
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'mailings', hash: this.getNewHash()}).catch(() => {})
    },
    goDashboard() {
      this.$router.push({ name: 'dashboard', hash: this.getNewHash()}).catch(() => {})
    },
    goMailings() {
      this.$router.push({ name: 'mailings', hash: this.getNewHash()}).catch(() => {})
    },
    goSettings() {
      this.$router.push({ name: 'settings', hash: this.getNewHash()}).catch(() => {})
    },
    logout() {
      this.$session.remove('user')
      this.$store.commit('clearUser')
      this.$router.push({ name: 'mailings', hash: this.getNewHash()}).catch(() => {})
    },
    newContact() {
      this.$store.commit('setPrevBreadcrumbs', null)
      this.$router.push({ name: 'contact.edit', params: { contact_id: 'new', title: this.$t('HEADER_NEW_CONTACT') }, hash: this.getNewHash()}).catch(() => {})
    },
    onSelect({id, text}) {
      this.$store.commit('setPrevBreadcrumbs', null)
      this.$router.push({ name: 'contact.edit', params: { contact_id: id, title: text }, hash: this.getNewHash()}).catch(() => {})
    },
    runSearchAll() {
      this.$router.push({ name: 'contact.search_all', params: { title: this.$t('RESULTS_ALL_CONTACTS')}, hash: this.getNewHash()}
        ).catch(() => {})
    },
    runSimpleSearch(simple_search) {
      this.$router.push({ name: 'contact.simple_search', params: { simple_search }, hash: this.getNewHash()}).catch(() => {})
    },
    getFlag(locale_lang) {
      let lang = this.langMap.find(a => a.locale_lang === locale_lang)
      return lang ? lang.flag : ''
    },
    changeLocale() {
      // (lang)
      // this.$i18n.locale = lang.locale
      // this.$vuetify.lang.current = lang.locale_lang
      // this.$emit('changeLocale', lang.id)
    },
    getNewHash() {
      const dt = new Date()
      return '##'+ (dt.getTime()*1000 + dt.getMilliseconds())
    }
  },
}
</script>

<style>

</style>
